import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useIsClient } from '@grandvisionhq/lib-utils-react';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { getAttrValue, isString, sanitizeStringForUrl, getLocalizedAttrValue } from '@grandvisionhq/utils';
import { getProductTypeName } from '../../helpers.js';

const useBrandLink = (product)=>{
    const { locale  } = useIntl();
    const { isSubcategoryPlpLinkingDisabled  } = useFeatureToggles();
    const isClient = useIsClient();
    const link = React.useMemo(()=>{
        var ref;
        if (isSubcategoryPlpLinkingDisabled) return '';
        if (!isClient) {
            return '';
        }
        const productType = getProductTypeName(product);
        const brand = getAttrValue(product.masterVariant, 'brand');
        if (!isString(brand) || brand === '') return '';
        const sanitizedBrand = sanitizeStringForUrl(brand);
        const path = ((ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) || '';
        const parts = path.split('/').filter((v)=>v !== ''
        );
        const isMultilingual = parts[0] ? /[[a-z]{2}_[A-Z]{2}/g.test(parts[0]) : false;
        const category = isMultilingual ? parts[1] : parts[0];
        const baseUrl = `/${isMultilingual ? `${parts[0]}/` : ''}${category}`;
        if (productType && CommerceToolsApi.isLenses(productType)) {
            const replacementFrequency = getLocalizedAttrValue(product.masterVariant, 'replacementFrequency', locale) || '';
            return `${baseUrl}/${encodeURIComponent(sanitizeStringForUrl(replacementFrequency))}/${encodeURIComponent(sanitizedBrand)}`;
        }
        if (productType && CommerceToolsApi.isSolutions(productType)) {
            const contactLensCareType = product && getLocalizedAttrValue(product.masterVariant, 'contactLensCareType', locale) || '';
            return `${baseUrl}/${encodeURIComponent(sanitizeStringForUrl(contactLensCareType))}/${encodeURIComponent(sanitizedBrand)}`;
        }
        return `${baseUrl}/${encodeURIComponent(sanitizedBrand)}`;
    }, [
        isSubcategoryPlpLinkingDisabled,
        isClient,
        product,
        locale
    ]);
    return link;
};

export { useBrandLink };
//# sourceMappingURL=use-brand-link.js.map
